import { createFileRoute } from '@tanstack/react-router';

import { loadConciliationMessages, loadConciliationScreens, suspenseAccountDetailScreen, suspenseAccountDetailSearch } from '@/modules/conciliation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Detalhe do Bolsão (router.tsx:1483-1487).
export const Route = createFileRoute('/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id')({
  validateSearch: suspenseAccountDetailSearch,
  staticData: { screen: suspenseAccountDetailScreen },
  loader: () => loadConciliationMessages(),
  component: lazyScreen(loadConciliationScreens, 'SuspenseAccountDetailRouteScreen'),
});
